<script>
    import {createEventDispatcher, onDestroy, onMount} from "svelte";

    const dispatch = createEventDispatcher();
    export let accept = "*/*";
    export let autoOpen = false;

    let inputFile;

    async function handleFileInput(event) {
        const files = event.target.files;

        if (files.length === 0) {
            return;
        }

        const file = files[0];
        const fileBytes = await readFileAsByteArray(file);
        const fileName = file.name;
        const fileExtension = file.name.split('.').pop();

        dispatch("change", {
            originalEvent: event,
            file: file,
            fileBytes: fileBytes,
            fileName: fileName,
            fileExtension: fileExtension
        });
    }

    function readFileAsByteArray(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                resolve(new Uint8Array(reader.result));
            };
            reader.onerror = reject;
            reader.readAsArrayBuffer(file);
        });
    }


    const componentUploadOpenCallback = () => uploadOpenCallback(inputFile);
    const componentUploadCloseCallback = () => uploadCloseCallback(inputFile);

    function uploadOpenCallback(inputFileRef) {
        if (inputFile === inputFileRef) {
            inputFile.removeEventListener('click', componentUploadOpenCallback);
            jQuery(window).on('focus', componentUploadCloseCallback);
        }
    }

    function uploadCloseCallback(inputFileRef) {
        if (inputFile === inputFileRef) {
            jQuery(window).unbind('focus', componentUploadCloseCallback);
            inputFile.addEventListener('click', componentUploadOpenCallback);

            setTimeout(() => {
                if (inputFile.files.length === 0) {
                    dispatch("cancel");
                }
            }, 750);
        }
    }

    onMount(() => {
        inputFile.addEventListener('click', componentUploadOpenCallback);

        if (autoOpen) {
            inputFile.click();
        }
    });

    onDestroy(() => {
        inputFile.removeEventListener('click', componentUploadOpenCallback);
        jQuery(window).unbind('focus', componentUploadCloseCallback);
    });
</script>

<!--TODO-? Migrate to Bootstrap Input. For now it is ok, because we are just using it as hidden field.-->
<input {...$$restProps} {accept} on:change={handleFileInput} type="file" bind:this={inputFile} />
